import styled from 'styled-components'
import Step, { COLORS, POSITION, STATE } from './step/Step.jsx'

const StepperWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  align-items: center;
`

const getPosition = ({ stepIndex, totalCount }) => {
  if (stepIndex === 0) return POSITION.FIRST
  if (stepIndex === totalCount - 1) return POSITION.LAST
  return POSITION.MIDDLE
}

const getState = ({ stepIndex, activeIndex }) => {
  if (stepIndex === activeIndex) return STATE.ACTIVE
  return stepIndex < activeIndex ? STATE.DONE : STATE.INACTIVE
}

const MAX_STEP_COUNT = 7

/**
 * @param {Object} props
 * @param {Array<{ icon: string, label: string, onClick: Function }>} props.steps
 * @param {number} props.active
 */
const Stepper = ({ steps, active, color = COLORS.DEFAULT }) => {
  steps = steps.slice(0, MAX_STEP_COUNT)
  active = Math.max(active, -1)
  active = Math.min(active, steps.length)

  const allStepsHaveLabels = steps.every((step) => step.label)
  return (
    <StepperWrapper>
      {steps.map(({ label, icon, to }, index) => (
        <Step
          key={'step_' + index}
          icon={icon || index + 1}
          label={allStepsHaveLabels && label}
          state={getState({ stepIndex: index, activeIndex: active })}
          position={getPosition({ stepIndex: index, totalCount: steps.length })}
          color={color}
          to={to}
        />
      ))}
    </StepperWrapper>
  )
}

export default Stepper
